/**
 * Created by az on 2017/7/24.
 */
import QbMessageCard from './QbMessageCard';

export default QbMessageCard;